import _ from 'lodash';
import { convertGsToHtml, convertHelpers, createStaticViewFromDataCollections } from "../../common/convert";
import { ammendAllDates } from '../../common/dateFormatting';
import { recreateDataHelpers } from "../../firestoreData/appData/fsRecreateData";
import { updateLinkHelpers } from '../../firestoreData/updates/subUpdates/fsUpdate_dataLInks';
import { updateDocumentHelpers } from '../../firestoreData/updates/subUpdates/fsUpdate_document';
import { settingsViewerTypes } from '../../viewSettings/actions/SettingsViewer';
import { createResponseTypes, createTypes } from "./CreateReducer";
import { viewDataModes } from './DataManagmentReducer';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps";
import { eventDataHelpers } from './reducerHelpers/eventDataHelpers';
import { responsePromiseHandler } from "./reducerHelpers/reponsePromiseHandler";

const rts = {
  createSpreadsheet: 'createSpreadsheet',
  handle_gsAmmendments: 'handle_gsAmmendments',
  handleAmmend_ammendGoogleViewType: 'handleAmmend_ammendGoogleViewType',
  handleAmmend_selectedProp: 'handleAmmend_selectedProp',
  handleAmmend_settingsViewer: 'handleAmmend_settingsViewer',
  handleCallback_updateOneByOne: 'handleCallback_updateOneByOne',
  handleCreate_eventDataFromGs: 'handleCreate_eventDataFromGs',
  handleCreate_eventFromGs: 'handleCreate_eventFromGs',
  handleCreate_googleSpreadsheetTab: 'handleCreate_googleSpreadsheetTab', // pending
  handleCreate_spreadsheet: 'handleCreate_spreadsheet',
  handleGet_googleSheet: 'handleGet_googleSheet',
  handleRefresh_googleSheet: 'handleRefresh_googleSheet',
  handleGet_googleSheetSimple: 'handleGet_googleSheetSimple',
  handleGet_previousPreviewInfo: 'handleGet_previousPreviewInfo',
  handleGet_settingsViewerProps: 'handleGet_settingsViewerProps',
  handleInit_googleSheetActive: 'handleInit_googleSheetActive',
  handleInit_googleSheetTabs: 'handleInit_googleSheetTabs',
  handleMerge_settings: 'handleMerge_settings',
  handlePreview: 'handlePreview',
  handleRecreate_dataCollectionsOneByOne: 'handleRecreate_dataCollectionsOneByOne',
  handleRecreateDataCollections: 'handleRecreateDataCollections',
  handleRecreateDataDocuments: 'handleRecreateDataDocuments',
  handleResponse_googleSheet: 'handleResponse_googleSheet',
  handleSet_activeMenuItem: 'handleSet_activeMenuItem',
  handleSet_changedItems: 'handleSet_changedItems',
  handleSet_dataCollection: 'handleSet_dataCollection',
  handleSet_googleMode: 'handleSet_googleMode',
  handleSet_newItems: 'handleSet_newItems',
  handleSet_previewInfo: 'handleSet_previewInfo',
  handleSet_projectOptions: 'handleSet_projectOptions',
  handleSet_themeColors: 'handleSet_themeColors',
  handleSet_updateOptions: 'handleSet_updateOptions',
  handleShow_newOnly: 'handleShow_newOnly',
  handleUpdate_dataCollectionsOneByOne: 'handleUpdate_dataCollectionsOneByOne',
  handleUpdate_googleSpreadsheetTab: 'handleUpdate_googleSpreadsheetTab',
  ...grts,
  ...createResponseTypes
}

export const googleSheetsTypes = {
  create: 'create',
  normal: 'normal',
  registration: 'registration',
  app: 'app',
}

export const googleModeTypes = {
  none: 'none',
  app: 'app',
  commit: 'commit',
  data: 'data',
  preview: 'preview',
  previewDirect: 'previewDirect',
  previewing: 'previewing',
  sheets: 'sheets',
}

export const googlePreviewTypes = {
  none: 'none',
  newFull: 'newFull',
  newDataOnly: 'newDataOnly',
  dataOnly: 'dataOnly'
}

export const googleViewTypes = {
  all: 'all',
  changed: 'changed',
  new: 'new',
  missing: 'missing',
}

export const googleConfirmationTypes = {
  create: 'create',
  createWithDataSheet: 'createWithDataSheet',
  data: 'data',
  sheetsData: 'sheetsData',
  settings: 'settings',
  recreate: 'recreate',
}


export const googleSheetsInitialState = (initState) => {
  return { ...initState, googleUpdateStatus: {}, googleViewType: googleViewTypes.all, googleActiveDataItems: {} }
};

export const googleSheetsReducer = (state, action) => {

  const { type, dispatch } = action

  const { fn_cls, authEmail, database_fns, appInfo, googleSheetsId, googleSheetsPreview, pathViews, logging, googleSheetsImportOptions, databaseProjectId, useAppDataLinks, appDataLinks, appDataDocuments } = state ?? {}
  const { gvviSettings, staticViews: staticViews_app } = appInfo ?? {}

  let _googleSheetsImportOptions = action.googleSheetsImportOptions ? action.googleSheetsImportOptions : googleSheetsImportOptions
  if (!_googleSheetsImportOptions) { _googleSheetsImportOptions = {} }

  const _gsh = googleSheetsHandlers(action.dispatch)
  const { handleResponse_googleSheet, handleFunctionResponse, handleCallback_updateOneByOne } = _gsh

  switch (type) {

    case rts.handleGet_googleSheetSimple:
      const cbgs = (d) => {
        console.log('d', d)
        const xxx = parseSheetData(d.values)
        console.log('xxx', xxx)
      }
      const cbgse = (de) => {
        console.log('de', de)
      }
      fn_cls.getGoogleSheetSimple(action.gsid, action.sheetName, cbgs, cbgse)
      return { ...state }

    // GETS the google sheets data
    case rts.handleGet_googleSheet:
      getDataFromGoogleSheets(action, fn_cls, { authEmail, fromCreate: action.fromCreate, pathViews, _googleSheetsImportOptions, appDataDocuments, staticViews_app, gvviSettings }, handleResponse_googleSheet)
      return { ...state, gsid: action.gsid, googleSheetsId: action.gsid, updating: true }

    case rts.handleRefresh_googleSheet:
      const _action = {
        gsid: state.gsid,
        googleSheetsId: state.googleSheetsId,
      }
      getDataFromGoogleSheets(_action, fn_cls, { fromCreate: action.fromCreate, pathViews, _googleSheetsImportOptions, appDataDocuments, staticViews_app, gvviSettings }, handleResponse_googleSheet)
      return { ...state, updating: true }

    case rts.handleResponse_googleSheet:

      const { gsResponse } = action

      console.log('gsResponse', gsResponse)

      const { success, _preview, _preview_alt, svs, dcs, result_fromGoogle, forDemo } = gsResponse ?? {}
      const { _newCounts } = _preview ?? {}

      if (success && useAppDataLinks && appDataLinks) {
        ammendGsWithDataLinks(_preview, appDataLinks)
      }

      return {
        ...state,
        result_fromGoogle,
        googleSheetsPreview: _preview,
        dashboardInfo_preview_alt: _preview_alt,
        googleModeType: googleModeTypes.app,
        googleSheetsData: dcs,
        _newCounts,
        previewStatic: svs,
        staticViews: svs,
        gsSuccess: success,
        updating: false,
      }

    case rts.handle_gsAmmendments:
      ammendDataFromGoogleSheets(state.googleSheetsPreview, null, { fromCreate: action.fromCreate, pathViews, _googleSheetsImportOptions, staticViews_app, gvviSettings }, handleResponse_googleSheet, action.googleSheetItems)
      return state

    case rts.handleInit_googleSheetTabs:
      const { _dataCollections, _googleSheetItems, _googleSheetKeys, _dataCounts } = initGoogleTabs(state)
      return { ...state, dataCollections: _dataCollections, googleSheetItems: _googleSheetItems, googleSheetKeys: _googleSheetKeys, dataCounts: _dataCounts }

    case rts.handleInit_googleSheetActive:
      const _dataCollection = state?.dataCollections?.[state?.activeMenuItem]
      const appDataDocument = action?.appDataDocuments?.[state?.activeMenuItem]
      const { _changedItems, _newItems, _missingItems, _itemChanges } = markChangedItemsByName(_dataCollection, appDataDocument)
      const _currentCount = state?.dataCounts[state?.activeMenuItem]
      return { ...state, updating: false, currentCount: _currentCount, activeTabName: 'Update All', googleActiveDataItems: _dataCollection, dataCollection: _dataCollection, changedItems: _changedItems, newItems: _newItems, missingItems: _missingItems, itemChanges: _itemChanges }

    case rts.handleGet_settingsViewerProps:
      return { ...state, settingsViewerProps: settingsViewerProps(action.viewDataMode, action.fromCreate, state.activeMenuItem, state) }

    case rts.handleMerge_settings:
      const _dashboardInfo_merged = eventDataHelpers.getMergedSettings(appDataDocuments, googleSheetsPreview, gvviSettings, staticViews_app, action.globalOnly, true, true)
      const _dashboardInfo_recreate = eventDataHelpers.getMergedSettings(appDataDocuments, googleSheetsPreview, gvviSettings, staticViews_app, action.globalOnly, false, true)
      console.log('_dashboardInfo_merged', _dashboardInfo_merged)
      return { ...state, dashboardInfo_merged: _dashboardInfo_merged, dashboardInfo_recreate: _dashboardInfo_recreate }

    case rts.handleAmmend_selectedProp:
      return { ...state, selectedProp: action.selectedProp }

    case rts.handleAmmend_settingsViewer:
      return { ...state, newSettings: action.newSettings }

    // create the event in  the database
    case rts.handleCreate_eventFromGs:
    case rts.handleCreate_eventDataFromGs:

      // createInfo, recreate, addModeType, config_alt, destination, viewDataMode

      const { destination, viewDataMode } = action
      const _createInfo = action.createInfo ? action.createInfo : { ...googleSheetsPreview }

      if (!_createInfo.projectData.clientData) {
        _createInfo.projectData.clientData = {
          clientMobileKey: pathViews.clients
        }
      }

      if (destination && destination.clientKey && _createInfo.projectData && _createInfo.projectData.clientData) {
        _createInfo.projectData.clientData.clientMobileKey = destination.clientKey
      }

      switch (viewDataMode) {
        case viewDataModes.createEvent_limited:
          if (_createInfo?.projectData?.dataCollections?.attendees) {
            _createInfo.projectData.dataCollections.attendees = _.fromPairs(_.take(_.toPairs(_createInfo.projectData.dataCollections.attendees), 50));
          }
          break;
        case viewDataModes.createGsEvent:
          if (_createInfo?.projectData?.dataCollections) {
            delete _createInfo?.projectData?.dataCollections
            delete _createInfo?.projectData?.staticViews
            delete _createInfo?.appDataDocuments
            delete _createInfo?.appDataLinks
          }
      }

      const cb = (result) => {
        responsePromiseHandler(result, handleFunctionResponse, dispatch)
      }

      fn_cls.createEventInDatabase(fn_cls, cb, _createInfo, action.recreate, logging, pathViews, databaseProjectId, action.addModeType, action.config_alt, destination)

      return state

    case rts.handleRecreateDataCollections:
      recreateDataHelpers.recreateAllDataCollections(state, action.collectionName, action.updateOnly).then(res => {
        dispatch({ type: grts.updateSuccess, dispatch, opts: { contentItems: res } })
      }).catch(error => {
        console.log('error', error)
      })
      return state

    case rts.handleRecreate_dataCollectionsOneByOne:
      recreateDataHelpers.recreateAllDataCollectionsOneByOne(state, action.collectionName, action.updateTheSettings, action.updateOnly, action.allowMerge, action.newOnly, handleCallback_updateOneByOne)
      return state

    case rts.handleUpdate_dataCollectionsOneByOne:
      recreateDataHelpers.recreateAllDataCollectionsOneByOne(state, action.collectionName, action.updateTheSettings, true, true, state.showNewOnly, handleCallback_updateOneByOne)
      return state

    case rts.handleRecreateDataDocuments:
      const { dataCollections } = state?.dashboardInfo_recreate?.projectData ?? {}
      updateDocumentHelpers.update_dataToDocuments(database_fns, singleProppathViews, dataCollections, dispatch)
      return state

    case rts.handleCallback_updateOneByOne:
      return { ...state, dcUpdates: action.done ? null : action.dcUpdates, updating: action.done ? null : state.updating }

    case rts.handleCreate_spreadsheet:
      fn_cls.createGoogleSpreadsheet(action.title).then(response_data => {
        const { success } = response_data ?? {}
        console.log('SUCCESS', success)
      })
      return state

    case rts.handleUpdate_googleSpreadsheetTab:
      fn_cls.updateGoogleSheetValues(googleSheetsId, action.tabName, action.values)
      return state

    case rts.handleCreate_googleSpreadsheetTab:
      fn_cls.createGoogleSpreadsheetTab(googleSheetsId, action.tabName, action.fetchFirestoreData, action.values).then(response_data => {
        dispatch({ type: rts.updateSuccess, dispatch })
      })
      return state

    case rts.handleSet_activeMenuItem:
      return { ...state, activeMenuItem: action.activeMenuItem }

    case rts.handleSet_googleMode:
      switch (action.googleModeType) {
        case googleModeTypes.none:
          return {
            ...state,
            googleModeType: googleModeTypes.none,
            googlePreviewType: googlePreviewTypes.none,
            googleSheetsPreview: null,
            googleUpdateStatus: null,
            showConfirmationQuestion: null
          }
        default:
          return {
            ...state,
            googleModeType: state.googleModeType === action.googleModeType ? googleModeTypes.none : action.googleModeType
          }
      }

    case rts.handleShow_newOnly:
      return { ...state, showNewOnly: !state.showNewOnly }

    case rts.handleSet_previewInfo:
      return { ...state, googleSheetsPreview: action.pi }

    case rts.handlePreview:
      const { dataOnly } = action.opts
      return {
        ...state,
        googlePreviewType: dataOnly ? googlePreviewTypes.newDataOnly : googlePreviewTypes.newFull,
        googleModeType: googleModeTypes.previewing
      }

    case rts.handleSet_dataCollection:
      return { ...state, dataCollection: action.dataCollection }

    case rts.handleSet_newItems:
      return { ...state, newItems: action.newItems }

    case rts.handleSet_changedItems:
      return { ...state, changedItems: action.changedItems }

    case rts.handleAmmend_ammendGoogleViewType:
      const { googleViewType } = action
      let _data;
      let _tabName
      switch (googleViewType) {
        case googleViewTypes.all:
          _data = state?.dataCollection
          _tabName = 'Update All'
          break;
        case googleViewTypes.changed:
          _data = state?.changedItems
          _tabName = 'Changed Only'
          break;
        case googleViewTypes.new:
          _data = state?.newItems
          _tabName = 'New Only'
          break;
        case googleViewTypes.missing:
          _data = state?.missingItems
          _tabName = 'Missing Only'
          break;
        default:
        // nothing
      }
      return { ...state, googleViewType: action.googleViewType, googleActiveDataItems: _data, activeTabName: _tabName }

    case rts.handleSet_updateOptions:
      return { ...state, googleSheetsImportOptions: action.googleSheetsImportOptions, storageRootPath: action.storageRootPath, logging: action.logging }

    case rts.handleSet_projectOptions:
      return { ...state, projectOptions: action.projectOptions }

    case rts.handleSet_themeColors:
      return { ...state, themeColors: action.themeColors }

    case rts.handleGet_previousPreviewInfo:
      const xxxx = eventDataHelpers.getPreviousPreviewInfo(googleSheetsPreview, action.previousEventSettings, state)
      return { ...state, ...xxxx, updating: null }

    case rts.handleStopUpdate:
      return { ...state, updating: null }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action,
        {
          dispatch,
          dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation,
          questionProps: null,
          updatingCaption: 'Creating',
        })

    default:
      return state;
  }
}

export const googleSheetsHandlers = (dispatch) => {
  return {
    handleInit_googleSheetTabs: () => { dispatch({ type: rts.handleInit_googleSheetTabs, dispatch }) },
    handleInit_googleSheetActive: (appDataDocuments) => { dispatch({ type: rts.handleInit_googleSheetActive, dispatch, appDataDocuments }) },
    handle_gsAmmendments: (googleSheetItems, fromCreate) => { dispatch({ type: rts.handle_gsAmmendments, dispatch, googleSheetItems, fromCreate }) },
    handleAmmend_selectedProp: (selectedProp) => { dispatch({ type: rts.handleAmmend_selectedProp, dispatch, selectedProp, }) },
    handleAmmend_settingsViewer: (newSettings) => { dispatch({ type: rts.handleAmmend_settingsViewer, dispatch, newSettings, }) },
    handleCallback_updateOneByOne: (dcUpdates, done) => { dispatch({ type: rts.handleCallback_updateOneByOne, dispatch, dcUpdates, done }) },
    handleCreate_eventDataFromGs: (eventOptions) => { dispatch({ type: rts.handleCreate_eventDataFromGs, dispatch, eventOptions }) },
    handleCreate_eventFromGs: (createInfo, recreate, addModeType, config_alt, destination, viewDataMode) => { dispatch({ type: rts.handleCreate_eventFromGs, dispatch, createInfo, recreate, addModeType, config_alt, destination, viewDataMode }) },
    handleCreate_googleSpreadsheetTab: (tabName, fetchFirestoreData, values) => { dispatch({ type: rts.handleCreate_googleSpreadsheetTab, dispatch, tabName, fetchFirestoreData, values }) },
    handleCreate_spreadsheet: (title) => { dispatch({ type: rts.handleCreate_spreadsheet, dispatch, title }) },
    handleGet_googleSheet: (gsid, useItemKey, fromCreate, forDemo) => { dispatch({ type: rts.handleGet_googleSheet, dispatch, gsid, useItemKey, fromCreate, forDemo }) },
    handleRefresh_googleSheet: () => { dispatch({ type: rts.handleRefresh_googleSheet, dispatch }) },
    handleGet_googleSheetSimple: (gsid, sheetName) => { dispatch({ type: rts.handleGet_googleSheetSimple, dispatch, gsid, sheetName }) },
    handleGet_previousPreviewInfo: (previousEventSettings) => { dispatch({ type: rts.handleGet_previousPreviewInfo, dispatch, previousEventSettings }) },
    handleGet_settingsViewerProps: (viewDataMode, fromCreate) => { dispatch({ type: rts.handleGet_settingsViewerProps, dispatch, viewDataMode, fromCreate }) },
    handleMerge_settings: (globalOnly) => { dispatch({ type: rts.handleMerge_settings, dispatch, globalOnly }) },
    handlePreview: (opts) => { dispatch({ type: rts.handlePreview, dispatch, opts }) },
    handleRecreate_dataCollectionsOneByOne: (collectionName, updateTheSettings, updateStaticViews, updateOnly, allowMerge, newOnly) => { dispatch({ type: rts.handleRecreate_dataCollectionsOneByOne, dispatch, collectionName, updateTheSettings, updateStaticViews, updateOnly, allowMerge, newOnly }) },
    handleRecreateDataCollections: (collectionName, updateOnly) => { dispatch({ type: rts.handleRecreateDataCollections, dispatch, collectionName, updateOnly }) },
    handleRecreateDataDocuments: () => { dispatch({ type: rts.handleRecreateDataDocuments, dispatch }) },
    handleResponse_googleSheet: (gsResponse) => { dispatch({ type: rts.handleResponse_googleSheet, dispatch, gsResponse }) },
    handleSet_activeMenuItem: (activeMenuItem) => { dispatch({ type: rts.handleSet_activeMenuItem, dispatch, activeMenuItem }) },
    handleSet_googleMode: (googleModeType) => { dispatch({ type: rts.handleSet_googleMode, dispatch, googleModeType }) },
    handleSet_previewInfo: (pi) => { dispatch({ type: rts.handleSet_previewInfo, dispatch, pi }) },
    handleSet_projectOptions: (projectOptions) => { dispatch({ type: rts.handleSet_projectOptions, dispatch, projectOptions }) },
    handleSet_themeColors: (themeColors) => { dispatch({ type: rts.handleSet_themeColors, dispatch, themeColors }) },
    handleSet_updateOptions: (googleSheetsImportOptions, storageRootPath, logging) => { dispatch({ type: rts.handleSet_updateOptions, dispatch, googleSheetsImportOptions, storageRootPath, logging }) },
    handleShow_newOnly: () => { dispatch({ type: rts.handleShow_newOnly, dispatch }) },
    handleUpdate_dataCollectionsOneByOne: (collectionName, updateTheSettings, updateStaticViews) => { dispatch({ type: rts.handleUpdate_dataCollectionsOneByOne, dispatch, collectionName, updateTheSettings, updateStaticViews }) },
    handleUpdate_googleSpreadsheetTab: (tabName, values) => { dispatch({ type: rts.handleUpdate_googleSpreadsheetTab, dispatch, tabName, values }) },
    handleAmmend_ammendGoogleViewType: (googleViewType) => { dispatch({ type: rts.handleAmmend_ammendGoogleViewType, dispatch, googleViewType }) },
    handleSet_dataCollection: (dataCollection) => { dispatch({ type: rts.handleSet_dataCollection, dispatch, dataCollection }) },
    handleSet_newItems: (newItems) => { dispatch({ type: rts.handleSet_newItems, dispatch, newItems }) },
    handleSet_changedItems: (changedItems) => { dispatch({ type: rts.handleSet_changedItems, dispatch, changedItems }) },
    ...responseHandlers(dispatch)
  }
}

function parseSheetData(sheetData) {
  if (!sheetData || sheetData.length < 3) return { sessions: [], attendees: [] };

  const headerRow = sheetData[0];
  const sessionKeyRow = sheetData[1];
  const dataRows = sheetData.slice(2);

  // Extract sessions
  const sessions = _.chain(headerRow)
    .slice(3)
    .map((name, idx) => {
      const _itemKey = sessionKeyRow[idx + 3];
      return _itemKey ? { _itemKey, name } : null;
    })
    .compact()
    .value();

  const sessionKeyIndexMap = _.reduce(
    sessions,
    (acc, session, idx) => {
      acc[idx + 3] = session._itemKey;
      return acc;
    },
    {}
  );

  // Extract attendees
  const attendees = dataRows.map((row) => {
    const _itemKey = row[1];
    const name = row[2];

    const enrolledSessions = Object.entries(sessionKeyIndexMap)
      .filter(([colIndex, key]) => row[colIndex] === 'X')
      .map(([_, key]) => key);

    return {
      _itemKey,
      name,
      sessions: enrolledSessions
    };
  });

  return { sessions, attendees };
}

const getDataFromGoogleSheets = async (action, fn_cls, opts, callback) => {
  const { gsid, fromCreate, forDemo } = action ?? {}
  const { pathViews, _googleSheetsImportOptions, appDataDocuments, staticViews_app, gvviSettings, authEmail } = opts
  const { aps_viewItems } = gvviSettings
  const formData = { googleSheetsId: gsid }
  const sheetProps = { formData, pathViews }
  const sheetOpts = {
    appArea: 'event',
    googleSheetsImportOptions: _googleSheetsImportOptions,
    logging: null,
    appDataDocuments,
    staticViews_app,
    forDataManagement: true,
    aps_viewItems,
    forDemo,
    authEmail,
    forceEmailAuth: false
  }
  // sheetProps, appArea, googleSheetsImportOptions, logging, appDataDocuments, staticViews_app, forDataManagement, aps_viewItems
  const response = await fn_cls.createProjectFromSheets(sheetProps, sheetOpts)
  const { success, result } = response ?? {}
  const _result = _.cloneDeep(result)
  const _opts = { ...opts, fromCreate, forDemo }
  if (success) {
    ammendDataFromGoogleSheets(result, _result, _opts, callback)
  } else {
    callback({ success: false })
  }
}

const ammendDataFromGoogleSheets = async (result_fromGoogle, _result_fromGoogle, opts, callback, googleSheetItems) => {

  const { projectData, projectSettings: projectSettings_gs, appDataDocuments, appDataLinks, _newCounts } = result_fromGoogle ?? {}
  const { viewItems, views } = projectSettings_gs ?? {}
  const { gvviSettings, pageSettings_app, fromCreate, forDemo } = opts ?? {}
  const { aps_global, aps_viewItems, aps_views } = gvviSettings ?? {}

  const _excluded = googleSheetItems ? _.filter(googleSheetItems, { included: false }) : []
  const excludedItemKeys = _excluded.map(item => item.key);

  if (excludedItemKeys.length > 0) {
    removeExcludedItems(viewItems, excludedItemKeys)
    removeExcludedItems(views, excludedItemKeys, true)
    removeExcludedItems(aps_viewItems, excludedItemKeys)
    removeExcludedItems(aps_views, excludedItemKeys)
    removeExcludedItems(aps_views, excludedItemKeys, true)
  }

  const { dataCollections } = projectData ?? {}

  const svs = createStaticViewFromDataCollections(dataCollections, aps_viewItems)
  if (dataCollections) { ammendAllDates(dataCollections, true) }
  convertGsToHtml(dataCollections)

  const {
    previewSettings: _projectSettings,
    previewSettings_gs_app: previewSettings_gs_app,
    previewSettings_app_gs: previewSettings_app_gs
  } = eventDataHelpers.getPreviewSettings(projectSettings_gs, gvviSettings, fromCreate)

  const _appDataDocuments = convertHelpers.createDocumentData(dataCollections)
  const _appDataLinks = updateLinkHelpers.createAppLinks(null, dataCollections)

  const _preview = {
    projectData: projectData,
    projectSettings: _projectSettings,
    appDataDocuments: _appDataDocuments,
    appDataLinks: _appDataLinks, // generated from dataCollections
  }

  const _preview_alt = {
    projectSettings_gs,
    previewSettings_gs_app: previewSettings_gs_app,
    previewSettings_app_gs: previewSettings_app_gs,
    appDataLinks_gs: appDataLinks,
    _newCounts: _newCounts,
  }

  callback({ success: true, _preview, _preview_alt, svs, dcs: dataCollections, result_fromGoogle: _result_fromGoogle, forDemo })
}

const removeExcludedItems = (items, excludedItemKeys, includeList) => {
  if (items && excludedItemKeys) {
    Object.keys(items).forEach(vik => {
      const _vik = includeList ? vik.replace('_list', '') : vik
      if (excludedItemKeys.includes(_vik)) {
        delete items[vik]
      }
    })
  }
}

const settingsViewerProps = (viewDataMode, fromCreate, activeMenuItem, state) => {

  const { googleSheetsPreview, dashboardInfo_recreate, dashboardInfo_merged } = state

  let ci;
  let createType = createTypes.updateSettings
  let _createType = fromCreate ? null : settingsViewerTypes.settingsOnly

  switch (viewDataMode) {

    case viewDataModes.addNewDataCollection:
      const projDCAs = {
        projectData: dashboardInfo_recreate?.projectData,
        projectCollection: activeMenuItem,
      }
      ci = projDCAs
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.addNewDataCollection
      break;

    case viewDataModes.mergeDataCollections:
      const projDCUs = {
        projectData: dashboardInfo_recreate?.projectData,
        projectCollection: activeMenuItem,
      }
      ci = projDCUs
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.mergeDataCollections
      break;

    case viewDataModes.mergeDataAndSettings:
      const projDSCUs = {
        projectData: dashboardInfo_recreate?.projectData,
        projectCollection: activeMenuItem,
      }
      ci = projDSCUs
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.mergeDataAndSettings
      break;

    case viewDataModes.mergeDataCollection:
      const projDCU = {
        projectData: dashboardInfo_recreate?.projectData,
        projectCollection: activeMenuItem,
      }
      ci = projDCU
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.mergeDataCollection
      break;

    case viewDataModes.recreateDataCollection:
      const projDC = {
        projectData: dashboardInfo_recreate?.projectData,
        projectCollection: activeMenuItem,
      }
      ci = projDC
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.recreateDataCollection
      break;

    case viewDataModes.recreateDataCollections:
      const projA = {
        projectData: dashboardInfo_recreate?.projectData
      }
      ci = projA
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.recreateDataCollections
      break;

    case viewDataModes.recreateDataDocuments:
      const projD = {
        projectData: dashboardInfo_recreate?.projectData
      }
      ci = projD
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.recreateDataDocuments
      break;

    case viewDataModes.recreateDataAndSettings:
      const projR = {
        projectSettings: dashboardInfo_recreate?.projectSettings,
        projectData: dashboardInfo_recreate?.projectData
      }
      ci = projR
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.recreateDataAndSettings
      break;

    case viewDataModes.mergeSettings:
      const projUM = {
        projectSettings: googleSheetsPreview?.projectSettings,
      }
      ci = projUM
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.mergeSettings
      break;

    case viewDataModes.recreateSettings:
      const projU = {
        projectSettings: googleSheetsPreview.projectSettings,
      }
      ci = projU
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.recreateSettings
      break;

    case viewDataModes.recreateGlobalSettings:
      const projG = {
        projectSettings: googleSheetsPreview.projectSettings,
      }
      ci = projG
      _createType = settingsViewerTypes.updateEvent
      createType = createTypes.recreateGlobalSettings
      break;

    default:
      ci = googleSheetsPreview
  }

  return { _createType, createType, ci }
}

const ammendGsWithDataLinks = (_preview, appDataLinks) => {
  if (_preview && _preview.projectData && _preview.projectData.dataCollections) {
    _.forEach(appDataLinks, (appDataLink, key) => {
      if (_preview.projectData.dataCollections[key]) {
        const _dataCollection = _preview.projectData.dataCollections[key]
        _.forEach(appDataLink, (item, key) => {
          if (_dataCollection[key]) {
            const di = _dataCollection[key]
            _.forEach(item, (propValue, propKey) => {
              if (!di[propKey]) {
                di[propKey] = propValue
              }
            })
          }
        })
      }
    })
  }
}

/**
 * 
 * @param {object} state 
 * @returns _dataCollections, _googleSheetItems, _googleSheetKeys, _dataCounts
 */
const initGoogleTabs = (state) => {
  const { googleSheetsPreview, _newCounts } = state
  const dataCollections = googleSheetsPreview?.projectData?.dataCollections
  if (dataCollections) {
    const _googleSheetKeys = _.sortBy(_.keys(dataCollections))
    const _googleSheetItems = {}
    _.forEach(_googleSheetKeys, gsk => {
      _googleSheetItems[gsk] = {
        name: gsk,
        included: true,
        key: gsk
      }
    })
    const _dataCounts = {}
    _.forEach(dataCollections, (dataCollection, dcKey) => {
      const dcl = Object.keys(dataCollection).length
      const newCount = _newCounts ? _newCounts[dcKey] : 0
      _dataCounts[dcKey] = {
        dcl,
        newCount
      }
    })
    return { _dataCollections: dataCollections, _googleSheetItems, _googleSheetKeys, _dataCounts }
  }
}

const markChangedItemsByName = (dc, appDataDoc) => {

  const _changedItems = {};
  const _newItems = {};
  const _missingItems = {};
  const _itemChanges = {};

  // Step 1: Identify changed and new items
  _.forEach(dc, (dataItem, key) => {


    if (dataItem) {
      // Find the corresponding item in `add` based on the 'name' property
      const correspondingItem = _.find(appDataDoc, { name: dataItem.name });

      // Omit `_itemKey` from both items before comparison
      const dataItemToCompare = _.omit(dataItem, '_itemKey');
      const correspondingItemToCompare = correspondingItem ? _.omit(correspondingItem, '_itemKey') : null;

      if (correspondingItem) {
        // Compare properties and track changes
        const changes = _.reduce(dataItemToCompare, (result, value, prop) => {
          if (!_.isEqual(value, correspondingItemToCompare[prop])) {
            result[prop] = { old: value, new: correspondingItemToCompare[prop] };
          }
          return result;
        }, {});

        if (!_.isEmpty(changes)) {
          dataItem._changed = true;
          _changedItems[key] = dataItem;
          _itemChanges[key] = changes;
        }
      } else {
        _newItems[key] = dataItem;
      }
    }

  });

  // Step 2: Identify missing items (items in `add` but not in `dc`)
  _.forEach(appDataDoc, (addItem, key) => {
    const correspondingItem = _.find(dc, { name: addItem.name });
    if (!correspondingItem) {
      _missingItems[key] = addItem;
    }
  });

  return { _changedItems, _newItems, _missingItems, _itemChanges };
};